import "./dateCell.scss";

export const DateCell = () => {
    return <div className="date-cell" />;
};
